import React from 'react';

interface FormStepLayoutProps {
  children: React.ReactNode;
  footer?: React.ReactNode;
  centerContent?: boolean;
}

export function FormStepLayout({
  children,
  footer,
  centerContent = false,
}: FormStepLayoutProps) {
  return (
    <div className="form-container">
      <div className="form-step w-full mx-auto flex flex-col flex-1 min-h-0">
        <div
          className={
            centerContent
              ? 'form-step-content flex flex-col'
              : 'form-step-content'
          }
        >
          <div className={centerContent ? 'my-auto w-full' : 'w-full'}>
            {children}
          </div>
        </div>
        {footer}
      </div>
    </div>
  );
}
